import customConnect from '../customConnect';
import {map} from '../map/map';
import {showPopup} from './actions';
import Overlay from 'ol/Overlay.js';


export default function(store) { //new props and action function

	var popup = new Overlay({
	  element: document.getElementById('mapPopup'),
	  positioning: 'bottom-right',
	  autopan: true,
	  offset: [-10, -10]
	});

	map.addOverlay(popup);

	var stateUpdateHandler = function(props) {

		popup.setPosition((props.coordinate.length > 0 ? props.coordinate : undefined));
	};

	const mapStateToPropsRes = (state) => {
		
		return {
			coordinate: state.popup.coords,
		//	layers: state.baseLayers.layers
		};
	};

	const mapDispatchToPropsRes = (dispatch) => {

	  return {
	  	interactionAddEvent: (props, coordinates) => {

	  		dispatch(showPopup({items: [props.name, TYPE_NAME_MAP[props.type], props.description], pixel: map.getPixelFromCoordinate(coordinates)}));
  		},
  		interactionRemoveEvent: () => {
  			
  			dispatch(showPopup(null));
  		}
	  };
	};

	customConnect(mapStateToPropsRes, mapDispatchToPropsRes, store, stateUpdateHandler);
}